import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post('/resume_experience_icfes/', data, {
    headers: {
      'Content-Type': `multipart/form-data;`,
    },
  });
};

const get = async (id) => {
  return await httpClient.get(`/resume_experience_icfes/${id}/`);
};

const put = async (id, data) => {
  return await httpClient.put(`/resume_experience_icfes/${id}/`, data, {
    headers: {
      'Content-Type': `multipart/form-data;`,
    },
  });
};

const remove = async (id) => {
  return await httpClient.delete(`/resume_experience_icfes/${id}`);
};

const filter = async (query) => {
  return await httpClient.get(`/resume_experience_icfes/${query}`);
};

export { post, get, put, remove, filter };
